var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAcom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.76h9.92V16H0v-2.24zM4.901 3.52a5.594 5.594 0 012.492.534c.726.355 1.089 1.027 1.089 2.013v3.757c0 .26.005.576.016.946-.006.199.04.396.133.571.086.11.2.196.329.248v.316H6.531a2.31 2.31 0 01-.141-.466 5.066 5.066 0 01-.063-.496 4.56 4.56 0 01-1.065.817c-.5.27-1.061.409-1.63.4a2.877 2.877 0 01-1.916-.635 2.219 2.219 0 01-.756-1.8A2.314 2.314 0 012.174 7.54a5.568 5.568 0 011.96-.526l.76-.09c.302-.025.6-.089.886-.188a.647.647 0 00.478-.609.714.714 0 00-.364-.694 2.36 2.36 0 00-1.07-.192 1.427 1.427 0 00-1.12.376c-.17.217-.279.477-.314.75H1.234A3.06 3.06 0 011.861 4.6c.59-.72 1.604-1.08 3.04-1.08zM6.25 7.923a2.469 2.469 0 01-.427.207c-.193.065-.391.114-.592.146l-.502.09a3.34 3.34 0 00-1.01.293.974.974 0 00-.518.909.938.938 0 00.32.792c.222.166.494.252.772.244.473.002.936-.14 1.328-.406.404-.27.615-.763.63-1.48l-.001-.795zM9.92 0v2.24H0V0h9.92z",
    fill: "#E60014"
  })));
}

export default SvgAcom;